var _rect, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.6875C17.3503 21.6875 21.6875 17.3503 21.6875 12C21.6875 6.64973 17.3503 2.3125 12 2.3125C6.64973 2.3125 2.3125 6.64973 2.3125 12C2.3125 17.3503 6.64973 21.6875 12 21.6875ZM18.067 9.94195L10.8795 17.1295C10.6354 17.3735 10.2396 17.3735 9.99555 17.1294L5.93305 13.0669C5.68898 12.8229 5.68898 12.4271 5.93305 12.183L6.81691 11.2992C7.06102 11.0551 7.45676 11.0551 7.70082 11.2992L10.4375 14.0359L16.2992 8.17422C16.5433 7.93012 16.939 7.93012 17.1831 8.17422L18.067 9.05809C18.311 9.30215 18.311 9.69789 18.067 9.94195Z",
    fill: "#137C40"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4763",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.6875C17.3503 21.6875 21.6875 17.3503 21.6875 12C21.6875 6.64973 17.3503 2.3125 12 2.3125C6.64973 2.3125 2.3125 6.64973 2.3125 12C2.3125 17.3503 6.64973 21.6875 12 21.6875ZM18.067 9.94195L10.8795 17.1295C10.6354 17.3735 10.2396 17.3735 9.99555 17.1294L5.93305 13.0669C5.68898 12.8229 5.68898 12.4271 5.93305 12.183L6.81691 11.2992C7.06102 11.0551 7.45676 11.0551 7.70082 11.2992L10.4375 14.0359L16.2992 8.17422C16.5433 7.93012 16.939 7.93012 17.1831 8.17422L18.067 9.05809C18.311 9.30215 18.311 9.69789 18.067 9.94195Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4763)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success-icon.45434f83577c760ccc551f4473992316.svg";